import React, { Component } from 'react'
import JewelryPanel from '../jewelry-panel'
import SelectItem from '../../select-item'
import Slider from '../../slider'
import Spacer from '../../spacer'
import BailDiamondPanel from './bail-diamond-panel'
import {
  showBailPanel
} from '../../../utils/jewelry-validation'

class BailPanel extends Component {
  render () {
    const props = this.props
    return (
      <JewelryPanel
        id='bailPanelContainer'
        show={showBailPanel(props)}
        isResetting={props.isResetting}>

        <Spacer lg />

        <SelectItem
          id='bail_panel'
          label='Bail?'
          labelId='bailPanel'
          options={[
            {value: false, label: 'No'},
            {value: true, label: 'Yes'}
          ]}
          value={props.has_bail}
          onChange={props.onChangeVal.bind(this, 'has_bail')}
          initVal={null}
        />

        <JewelryPanel
          id='bailPanel'
          show={this.props.has_bail}
          isResetting={props.isResetting}>

          <Spacer xxs />

          <SelectItem
            id='bail_type'
            label='Bail Type'
            labelId='bailType'
            options={[
              {value: 'straight', label: 'Straight'},
              {value: 'tapered', label: 'Tapered'}
            ]}
            value={props.bail_type}
            onChange={props.onChangeVal.bind(this, 'bail_type')}
            initVal={null}
          />

          <Spacer xxs />

          <h4>Bail Length</h4>
          <Slider
            id='bail_length_in_mm'
            labelRight='mm'
            single
            input
            min={1.5}
            max={15.0}
            step={0.1}
            value={props.bail_length_in_mm}
            onChange={props.onChangeVal.bind(this, 'bail_length_in_mm')}
            initVal={1.5}
          />

          <JewelryPanel
            id='bailStraightWidthPanel'
            show={this.props.bail_type === 'straight'}
            isResetting={props.isResetting}>

            <Spacer xxs />

            <h4>Bail Width (Straight)</h4>
            <Slider
              id='bail_straight_width_in_mm'
              labelRight='mm'
              single
              input
              min={1.5}
              max={15.0}
              step={0.1}
              value={props.bail_straight_width_in_mm}
              onChange={props.onChangeVal.bind(this, 'bail_straight_width_in_mm')}
              initVal={1.5}
            />
          </JewelryPanel>

          <JewelryPanel
            id='bailTaperedWidthPanel'
            show={this.props.bail_type === 'tapered'}
            isResetting={props.isResetting}>

            <Spacer xxs />

            <h4>Bail Width (Tapered)</h4>
            <Slider
              id='bail_tapered_min_width_in_mm'
              sliderId='bailTaperedWidth'
              labelRight='mm'
              double
              inputs
              min={1.0}
              max={14.5}
              step={0.1}
              minDistance={0.1}
              value={props.bail_tapered_width_in_mm}
              onChange={props.onChangeVal.bind(this, 'bail_tapered_width_in_mm')}
              initVal={[1.0, 14.5]}
            />
          </JewelryPanel>

          <BailDiamondPanel {...props} onChange={props.onChangeVal} />

        </JewelryPanel>
      </JewelryPanel>
    )
  }
}

export default BailPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/bail-panel/index.js